import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/api/global.service';
import { ToolsService } from 'src/app/utils/tools.service';
import AlertifyHelper from 'src/app/utils/utils';
declare var $: any;
import * as moment from 'moment';
import { SearchGuidesComponent } from 'src/app/components/search-guides/search-guides.component';
import { ScheduleService } from 'src/app/api/departure/schedule.service';
import { LoadingModalComponent } from 'src/app/components/loading-modal/loading-modal.component';
import * as Highcharts from 'highcharts';
import HC_heatmap from 'highcharts/modules/heatmap';
import HC_more from 'highcharts/highcharts-more';
import HC_exporting from 'highcharts/modules/exporting';
import { GroupService } from 'src/app/api/departure/group.service';
// Inicializa los módulos

HC_exporting(Highcharts);
moment.locale('es');
HC_more(Highcharts);
HC_heatmap(Highcharts);

@Component({
  selector: 'app-guide-report',
  templateUrl: './guide-report.component.html',
  styleUrls: ['./guide-report.component.css']
})
export class GuideReportComponent implements OnInit {
  @ViewChild(LoadingModalComponent) LoadingModalComponent: any;
  @ViewChild(SearchGuidesComponent) SearchGuidesComponent: any;
  private thisComponent: GuideReportComponent;

  branchofficeSlug = '';
  items: any = [];
  start_range: any = moment()
    .subtract(1, 'month')
    .startOf('month');
  end_range: any = moment()
    .subtract(1, 'month')
    .endOf('month');
  total_groups: any = 0;
  total_pax: any = 0;

  // variables
  activeTab: string = 'home';
  guideSelected: any = null;
  is_all: boolean = false;

  // arr_variables
  items_transport: any = [];

  // variables para gráfico
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {};
  chart: Highcharts.Chart | undefined;
  updateFlag: boolean = false; // Flag para forzar la actualización

  // variables : list_group =======
  items_group: any = [];
  page = 1;
  count = 0;
  params: any = {
    search: '',
    tour_id: null
  };
  dataPagination: any = {
    pageSize: 0,
    currentPage: this.page,
    totalItems: 0
  };

  // variables para calendario de salidas
  HighchartsHeatmap: typeof Highcharts = Highcharts;
  chartOptionsHeatmap: Highcharts.Options = {};
  chartHeatmap: Highcharts.Chart | undefined;
  updateFlagHeatmap: boolean = false;
  start_range_calendar: any = moment().startOf('month');
  end_range_calendar: any = moment().endOf('month');

  data_calendar: any = [
    // { description: 'laguna azul', date_departure: '02-07-2025' }
  ];

  constructor(
    private router: Router,
    private globalService: GlobalService,
    public toolsService: ToolsService,
    private groupService: GroupService,
    private scheduleService: ScheduleService,
    private alertifyMsg: AlertifyHelper
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.thisComponent = this;
  }

  ngOnInit() {
    this.generateGraph();
    this.generateGraphicCalendar();
  }

  selectedGuideSearch(item_: any) {
    this.guideSelected = item_;

    this.getDataViewGeneral();
    setTimeout(() => {
      this.generateCalendar();
    }, 150);
  }

  removeGuide() {
    this.guideSelected = null;
    setTimeout(() => {
      this.SearchGuidesComponent.focused();
    }, 150);
  }

  isAll() {
    // if (this.is_all) {
    //   this.SearchTourComponent.isDisabled();
    // } else {
    //   this.SearchTourComponent.notDisabled();
    // }
    // this.params.is_all = this.is_all;
    console.log(this.is_all);
  }

  setActiveTab(tab: string) {
    this.activeTab = tab;
    if (this.activeTab == 'home') {
    }

    if (this.activeTab == 'list_group') {
      this.getDataViewListGroup();
    }

    if (this.activeTab == 'list_calendar') {
      this.generateCalendarRange();
      this.getDataViewCalendar();
      // this.generateGraphicCalendar();
    }
  }

  // cotenidos de TABS
  // ***** GENERAL =========================
  generateCalendar() {
    let component_ = this.thisComponent;
    (<any>$('#date_range_projection')).daterangepicker(
      {
        locale: {
          format: 'YYYY-MM-DD',
          separator: ' - ',
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar',
          fromLabel: 'Desde',
          toLabel: 'Hasta',
          customRangeLabel: 'Personalizado',
          daysOfWeek: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
          monthNames: [
            'Enero',
            'Febrero',
            'Marzo',
            'Abril',
            'Mayo',
            'Junio',
            'Julio',
            'Agosto',
            'Septiembre',
            'Octubre',
            'Noviembre',
            'Diciembre'
          ],
          firstDay: 1
        },
        ranges: {
          'Este mes': [moment().startOf('month'), moment().endOf('month')],
          'Último mes': [moment().subtract(30, 'days'), moment()],
          'Últimos 3 meses': [moment().subtract(3, 'months'), moment()],
          'Último año': [
            moment()
              .subtract(1, 'year')
              .startOf('year'),
            moment()
              .subtract(1, 'year')
              .endOf('year')
          ],
          'Semana actual': [moment().startOf('week'), moment().endOf('week')]
          // 'Personalizado' es el calendario por defecto del plugin
        },
        startDate: component_.start_range,
        endDate: component_.end_range,
        showDropdowns: true
      },
      function(start_date: any, end_date: any) {
        component_.start_range = start_date;
        component_.end_range = end_date;
        component_.resetGraph();
        component_.getDataViewGeneral();
      }
    );
  }

  getDataViewGeneral() {
    this.LoadingModalComponent.show();
    let val_params =
      'start_range=' +
      this.start_range.format('YYYY-MM-DD') +
      '&end_range=' +
      this.end_range.format('YYYY-MM-DD') +
      '&guide_id=' +
      this.guideSelected.id;

    this.scheduleService.summaryToursByGuide(val_params).subscribe({
      next: (data: any) => {
        let results = data.results;
        this.items = results;
        this.items_transport = data.results_transport;
        let series: any = [];
        for (let i in results) {
          let arr_data: any = [];
          arr_data.push(results[i].quantity_groups);
          let obj_: any = {
            name: results[i].description,
            data: results[i].quantity_groups
            // type: 'line'
          };
          series.push(obj_);
          // calcular totales para tabla
          this.total_groups = this.total_groups + results[i].quantity_groups;
          this.total_pax = this.total_pax + results[i].quantity_pax;
        }

        setTimeout(() => {
          this.updateChartData(series);
        }, 150);
      }
    });
  }

  generateGraph(series_data: any = []) {
    this.chartOptions = {
      chart: {
        type: 'column',
        marginTop: 100
      },
      title: {
        text: 'Resumen de grupos asignados ',
        style: {
          fontSize: '1em'
        },
        align: 'left'
      },
      tooltip: {
        headerFormat:
          '<div class="text-center"><b>FECHA:{point.key}</b></div><br/>', // Muestra el valor de xAxis
        pointFormat: '{series.name}: <b>{point.y:0f} </b>',
        style: {
          color: '#333333', // Color del texto
          fontSize: '12px',
          fontFamily: 'Arial' // Familia de fuente
        }
      },
      yAxis: {
        title: {
          text: 'N° de Grupos Asignados'
        }
      },
      xAxis: {
        title: {
          text:
            'Rango de fechas (' +
            this.start_range.format('YYYY-MM-DD') +
            ' - ' +
            this.end_range.format('YYYY-MM-DD') +
            ')',
          y: 10 // Ajusta este valor para desplazar el texto hacia abajo
        }
      },
      legend: {
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'middle',
        itemStyle: {
          fontSize: '11px'
        }
      },
      plotOptions: {
        column: {
          borderWidth: 0
        }
      },
      series: series_data,
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom'
              }
            }
          }
        ]
      }
    };
  }

  updateChartData(series: any) {
    if (this.chart) {
      // Eliminar series anteriores
      this.chart.series.forEach((serie: Highcharts.Series) => {
        serie.remove(false);
      });

      // Nombres de categorías (tours)
      const categories = series.map((s: any) => s.name);

      // Datos con colores y etiquetas
      const dataValues = series.map((s: any, index: number) => ({
        y: s.data,
        color: Highcharts.getOptions().colors?.[index % 10],
        name: s.name
      }));

      // Agregar nueva serie
      this.chart.addSeries(
        {
          type: 'column',
          name: 'N° de Grupos',
          data: dataValues,
          dataLabels: {
            enabled: true,
            inside: false,
            color: '#000',
            style: {
              fontSize: '11px'
            }
          }
        } as Highcharts.SeriesColumnOptions,
        false
      );

      // Actualizar gráfico
      this.chart.update({
        title: {
          text:
            'Resumen de grupos asignados al guia por cada Tour: Fechas (' +
            this.start_range
              .locale('es')
              .format('DD MMM YYYY')
              .toLowerCase() +
            ' - ' +
            this.end_range
              .locale('es')
              .format('DD MMM YYYY')
              .toLowerCase() +
            ')',
          style: {
            fontSize: '1em'
          },
          y: 20 // 🔧 Desplaza el título hacia abajo
        },
        xAxis: {
          categories: categories,
          labels: {
            rotation: -45,
            style: {
              fontSize: '11px'
            }
          },
          title: {
            text: 'LISTA DE TOURS',
            y: 10
          }
        },
        plotOptions: {
          column: {
            borderWidth: 0
          }
        },
        legend: {
          enabled: false
        }
      });

      this.chart.redraw();
      this.LoadingModalComponent.hide();
    }
  }

  resetGraph() {
    if (this.chart) {
      // Eliminar todas las series
      while (this.chart.series.length > 0) {
        this.chart.series[0].remove(false); // Eliminar la primera serie hasta que no haya más
      }

      // Desactivar la leyenda
      this.chart.update({
        legend: {
          enabled: false // Desactivar la leyenda
        }
      });

      // Redibujar el gráfico
      this.chart.redraw();
    }
  }

  // Recibir la referencia del gráfico cuando se crea
  onChartInstance(chartInstance: Highcharts.Chart) {
    this.chart = chartInstance;
  }

  printerSummaryGuideByTour() {
    (<any>$('#summaryGuideByTour')).printThis({
      importCSS: true,
      header: `
      <div style="text-align:center; margin-bottom:15px; margin-top:30px;">
        <p style="margin: 0; font-weight: bold; font-size: 16px;">GUÍA TURÍSTICO: ${this.guideSelected.fullname}</p>
        <hr />
      </div>
    `
    });
  }

  printerSummaryGuideByTransport() {
    (<any>$('#summaryGuideByTransport')).printThis({
      importCSS: true,
      header: `
      <div style="text-align:center; margin-bottom:15px; margin-top:30px;">
        <p style="margin: 0; font-weight: bold; font-size: 16px;">GUÍA TURÍSTICO: ${this.guideSelected.fullname}</p>
        <hr />
      </div>
    `
    });
  }
  // *********************

  // ***** LIST GROUP =========================
  getDataViewListGroup() {
    let val_params =
      'search=' +
      this.params.search +
      '&page=' +
      this.page +
      '&guide_id=' +
      this.guideSelected.id;
    this.groupService.listReportGroups(val_params).subscribe({
      next: (data: any) => {
        this.items_group = data.results;
        this.dataPagination.pageSize = data.paginate_by;
        this.dataPagination.currentPage = this.page;
        this.dataPagination.totalItems = data.total;
      }
    });
  }

  handlePageChange(event: any): void {
    this.page = event;
    this.getDataViewListGroup();
  }

  // *********************

  // ***** LIST CALENDAR =========================

  generateCalendarRange() {
    const selectedMoment = moment(); // mes actual

    // Asignar por defecto el valor al input
    ($('#date_calendar') as any).val(selectedMoment.format('YYYY-MM'));

    // Setear valores por defecto en las variables de rango
    this.start_range_calendar = selectedMoment.clone().startOf('month');
    this.end_range_calendar = selectedMoment.clone().endOf('month');

    // Inicializar el datepicker
    setTimeout(() => {
      ($('#date_calendar') as any)
        .datepicker({
          format: 'yyyy-mm',
          startView: 1,
          minViewMode: 1,
          language: 'es',
          autoclose: true
        })
        .on('changeDate', (e: any) => {
          const selectedMoment = moment(e.date);

          this.start_range_calendar = selectedMoment.clone().startOf('month');
          this.end_range_calendar = selectedMoment.clone().endOf('month');

          this.getDataViewCalendar();
        });
    }, 150);
  }

  getDataViewCalendar() {
    this.LoadingModalComponent.show();
    let val_params =
      'start_range=' +
      this.start_range_calendar.format('YYYY-MM-DD') +
      '&end_range=' +
      this.end_range_calendar.format('YYYY-MM-DD') +
      '&guide_id=' +
      this.guideSelected.id;

    this.scheduleService.summaryCalendarByGuide(val_params).subscribe({
      next: (data: any) => {
        this.data_calendar = data.results;
        // datos pasados
        const selectedYear = this.start_range_calendar.year();
        const selectedMonth = this.start_range_calendar.month(); // 0-indexed
        const seriesData = this.generateCalendarHeatmapData(this.data_calendar, selectedYear, selectedMonth);
        const titulo =
          'Calendario de Salidas del Mes: ' +
          this.start_range_calendar.format('MMMM YYYY');
        this.updateHeatmapCalendar(seriesData, titulo);
      }
    });
  }

  generateGraphicCalendar() {
    const selectedYear = this.start_range_calendar.year();
    const selectedMonth = this.start_range_calendar.month(); // 0-indexed
    this.chartOptionsHeatmap = {
      chart: {
        type: 'heatmap'
        // height: 400
      },
      title: {
        text: 'Calendario de Tours del Mes '+
        this.start_range_calendar.format('MMMM YYYY')
      },
      xAxis: {
        categories: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
        title: { text: null }
      },
      yAxis: {
        visible: false,
        min: 0,
        max: 5
      },
      tooltip: {
        formatter: function() {
          const point: any = this.point; // <-- aquí está el truco
          return point.value
            ? `<b>${point.nombre}</b><br>Día ${point.dayNumber}`
            : `Día ${point.dayNumber}`;
        }
      },
      // colorAxis: {
      //   min: 0,
      //   max: 1,
      //   minColor: '#FFFFFF',
      //   maxColor: '#00BFFF' // Azul para día con tour
      // },
      series: [
        {
          type: 'heatmap', // ✅ Obligatorio para evitar el error
          name: 'Días de la Semana',
          borderWidth: 1,
          data: this.generateCalendarHeatmapData(this.data_calendar, selectedYear, selectedMonth),
          dataLabels: {
            enabled: true,
            useHTML: true,
            formatter: function() {
              const p: any = this.point;
              if (!p.nombre) return `<span><b>${p.dayNumber}</b></span>`;
              return `<div style="text-align:center">
                        <div style="font-size: 10px"><b>${p.dayNumber}</b></div>
                        <div style="font-size: 10px; margin-top:5px">${p.nombre}</div>
                      </div>`;
            },
            color: '#000',
            style: {
              fontSize: '11px',
              textOutline: 'none'
            }
          }
        } as Highcharts.SeriesHeatmapOptions
      ]
    };
  }

  generateCalendarHeatmapData(data: any[], year: number, month: number): any[] {
    const result: any[] = [];
    const daysInMonth = new Date(year, month + 1, 0).getDate();
  
    // Agrupar por fecha en formato DD-MM-YYYY
    const grouped: { [fecha: string]: string[] } = {};
  
    data.forEach(d => {
      const momentFecha = moment(d.date_departure, 'YYYY-MM-DD');
      const fecha = momentFecha.format('DD-MM-YYYY'); // Convertimos a formato clave
      if (!grouped[fecha]) {
        grouped[fecha] = [];
      }
      grouped[fecha].push(d.description);
    });
  
    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month, day);
      const weekday = date.getDay(); // 0 (Dom) - 6 (Sáb)
      const weekOfMonth = Math.floor(
        (day + new Date(year, month, 1).getDay() - 1) / 7
      );
  
      const dayStr = `${String(day).padStart(2, '0')}-${String(month + 1).padStart(2, '0')}-${year}`;
      const tours = grouped[dayStr] || [];
  
      result.push({
        x: weekday,
        y: 5 - weekOfMonth, // Para invertir verticalmente
        dayNumber: day,
        nombre: tours.length ? tours.join('<br>') : null,
        value: tours.length ? 1 : null
      });
    }
  
    return result;
  }

  updateHeatmapCalendar(seriesData: any[], titulo: string) {
    if (this.chartHeatmap) {
      // Eliminar series anteriores
      this.chartHeatmap.series.forEach((serie: Highcharts.Series) => {
        serie.remove(false);
      });

      // Agregar nueva serie heatmap
      this.chartHeatmap.addSeries(
        {
          type: 'heatmap',
          name: 'Días de la Semana',
          borderWidth: 1,
          data: seriesData,
          dataLabels: {
            enabled: true,
            useHTML: true,
            formatter: function() {
              const p: any = this.point;
              if (!p.nombre) return `<span><b>${p.dayNumber}</b></span>`;
              return `<div style="text-align:center">
                        <div style="font-size: 10px"><b>${p.dayNumber}</b></div>
                        <div style="font-size: 10px; margin-top:5px">${p.nombre}</div>
                      </div>`;
            },
            color: '#000',
            style: {
              fontSize: '11px',
              textOutline: 'none'
            }
          }
        } as Highcharts.SeriesHeatmapOptions,
        false
      );

      // Actualiza el título dinámicamente
      this.chartHeatmap.update({
        title: {
          text: titulo
        },
        xAxis: {
          categories: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb']
        },
        yAxis: {
          visible: false,
          min: 0,
          max: 5
        },
        tooltip: {
          formatter: function() {
            const point: any = this.point;
            return point.value
              ? `<b>${point.nombre}</b><br>Día ${point.dayNumber}`
              : `Día ${point.dayNumber}`;
          }
        },
        colorAxis: {
          min: 0,
          max: 1,
          minColor: '#FFFFFF',
          maxColor: '#00BFFF'
        }
      });

      this.chartHeatmap.redraw();
      this.LoadingModalComponent.hide();
    }
  }

  // *******************************

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/reportes/lista']);
  }
}
